import type { IconAsset } from '../Icon.types';

export const arrowRight: IconAsset = {
  bold: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='m9.4081 7.5-4.954-4.954 2.1213-2.1213 8.5753 8.5754-8.5753 8.5754-2.1213-2.1213 4.954-4.9541h-9.4081v-3h9.4081z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='m9.2868 6.5-3.954-3.954 2.1213-2.1213 7.5753 7.5754-7.5753 7.5754-2.1213-2.1213 3.954-3.9541h-8.4081v-3h8.4081z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='m7.2868 5.5-2.954-2.9541 2.1213-2.1213 6.5753 6.5754-6.5753 6.5754-2.1213-2.1214 2.954-2.954h-6.4081v-3h6.4081z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M11.1716 8L5.36396 2.1924L6.77818 0.778183L15 9L6.77818 17.2218L5.36396 15.8076L11.1716 10H0.556351V8H11.1716Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='m9.1738 7-4.8076-4.8076 1.4142-1.4142 7.2196 7.2196-7.2196 7.2196-1.4142-1.4142 4.8031-4.8031h-8.6107v-2h8.6152z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='m7.2641 5-3.2929-3.2929 1.4142-1.4142 5.6146 5.6146-5.6146 5.6146-1.4142-1.4142 3.1079-3.1079h-6.4008v-2h6.5858z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
